package com.patronat.top.features.auth.presentation.ui

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.patronat.top.dto.UserRole
import com.patronat.top.features.auth.presentation.AuthEvent
import com.patronat.top.features.auth.presentation.AuthViewModel
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.atoms.inputs.InputState
import com.patronat.top.ui.molecules.branding.AppLogo
import com.patronat.top.ui.molecules.inputs.AppInput
import com.patronat.top.ui.molecules.inputs.AppInputMode
import com.patronat.top.ui.theme.AppIcons
import com.patronat.top.ui.theme.BodyMedium
import com.patronat.top.ui.theme.LabelLarge
import org.jetbrains.compose.resources.stringResource
import top.features.auth.generated.resources.Res
import top.features.auth.generated.resources.*

@Composable
fun RegistrationContent(viewModel: AuthViewModel) {
    val state by viewModel.viewState.collectAsState()

    LaunchedEffect(Unit) {
        viewModel.onEvent(AuthEvent.OnAuthDataChanged(role = UserRole.BUSINESS_OWNER))
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .padding(vertical = 24.dp),
        horizontalAlignment = Alignment.Start,
        verticalArrangement = Arrangement.Center
    ) {


        AppLogo()

        Spacer(modifier = Modifier.height(24.dp))


        Text(
            text = stringResource(Res.string.reg_step_1_title),
            style = LabelLarge.copy(fontSize = 24.sp)
        )
        Spacer(modifier = Modifier.height(8.dp))
        Text(
            text = stringResource(Res.string.reg_step_1_subtitle),
            style = BodyMedium
        )
        Spacer(modifier = Modifier.height(32.dp))


        AppInput(
            value = state.lastName,
            onValueChange = { viewModel.onEvent(AuthEvent.OnAuthDataChanged(lastName = it)) },
            label = stringResource(Res.string.label_lastname),
            placeholder = stringResource(Res.string.placeholder_lastname),
            leadingIcon = AppIcons.Profile,
            hint = state.lastNameError?.asString(),
            forceState = if (state.lastNameError != null) InputState.Error else null
        )
        Spacer(modifier = Modifier.height(16.dp))

        AppInput(
            value = state.firstName,
            onValueChange = { viewModel.onEvent(AuthEvent.OnAuthDataChanged(firstName = it)) },
            label = stringResource(Res.string.label_firstname),
            placeholder = stringResource(Res.string.placeholder_firstname),
            leadingIcon = AppIcons.Profile,
            hint = state.firstNameError?.asString(),
            forceState = if (state.firstNameError != null) InputState.Error else null
        )

        Spacer(modifier = Modifier.height(16.dp))

        AppInput(
            value = state.email,
            onValueChange = { viewModel.onEvent(AuthEvent.OnAuthDataChanged(email = it)) },
            label = stringResource(Res.string.label_email_required),
            placeholder = "youremail@gmail.com",
            leadingIcon = AppIcons.Email,
            hint = state.emailError?.asString(),
            forceState = if (state.emailError != null) InputState.Error else null
        )

        Spacer(modifier = Modifier.height(16.dp))

        AppInput(
            value = state.phone,
            onValueChange = { viewModel.onEvent(AuthEvent.OnAuthDataChanged(phone = it)) },
            label = stringResource(Res.string.label_phone_required),
            placeholder = "+38 (050) 000 0000",
            hint = state.phoneError?.asString(),
            forceState = if (state.phoneError != null) InputState.Error else null,
            inputMode = AppInputMode.Phone
        )

        Spacer(modifier = Modifier.height(32.dp))

        AppButton(
            text = stringResource(Res.string.action_continue),
            onClick = { viewModel.onEvent(AuthEvent.OnSubmitRegister) },
            modifier = Modifier.fillMaxWidth(),
            type = ButtonType.BrownFilled,
            isLoading = state.isLoading
        )

        Spacer(modifier = Modifier.height(20.dp))
    }
}
